import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';

function SignUp() {
    
    const [formData, setFormData] = useState({
      username: '',
      first_name: '',
      last_name: '',
      email: '',
      password: '',
      city: '',
      state: '',
      zip_code: '',
      streetAddress: '',
    });
    const navigate = useNavigate();
    const handleSubmit = async (event) => {
      event.preventDefault();
      //console.log('Form submitted with value:', formData);
      // Add your submission logic here, e.g., sending data to an API
      // useEffect(() => {
      //   fetch('https://ya9pql1cta.execute-api.us-east-1.amazonaws.com/default/signUp')
      //     .then(res => res.json())
      //     .then(data => setResponse(data))
      //     .catch(err => console.error(err));
      //   }, []);
      // console.log("products");
      // console.log(products);

      console.log(formData);

      try {
        const response = await fetch(process.env.REACT_APP_SIGN_UP_URL, {
          method: 'POST',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Accept': '*/*',
            'Connection': 'keep-alive'          },
          body: JSON.stringify(formData),
        });
  
        await response.json();
  
        if (response.ok) {
          navigate('/verifyCode');
        }
      } catch (error) {
      }     
    };

    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData(prevData => ({
        ...prevData,
        [name]: value,
      }));
      // double post the email as the username
      if (name === 'email') {
        setFormData(prevData => ({
          ...prevData,
          username: value,
        }));
      }
    };

    // const [signUpResponse, setSignUpResponse] = useState([]);
      
    //     useEffect(() => {
    //       fetch('https://n583lmjao2.execute-api.us-east-1.amazonaws.com/default/getProducts')
    //         .then(res => res.json())
    //         .then(data => setSignUpResponse(data))
    //         .catch(err => console.error(err));
    //     }, []);
    //   console.log("sign up response");
    //   console.log(signUpResponse);

      return (
    <div >


<div className="page-header align-items-start min-height-300 m-3 border-radius-xl bg-gray-100" style={{ backgroundImage: `url('https://images.unsplash.com/photo-1545569341-9eb8b30979d9?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80')`, backgroundSize: 'cover', backgroundPosition: 'center' }} loading="lazy">
    <span className="mask bg-gradient-dark opacity-4"></span>
  </div>
  <div className="container">
    <div className="row mt-lg-n12 mt-md-n12 mt-n11 justify-content-center">
      <div className="col-xl-4 col-lg-5 col-md-7 mx-auto">
        <div className="card mt-8">
          <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
            <div className="bg-gradient-dark shadow-dark border-radius-lg py-3 pe-1 text-center py-4">
              <h4 className="font-weight-bolder text-white mt-1">Join us today</h4>
              <p className="mb-1 text-white text-sm">Enter your email and password to register</p>
            </div>
          </div>
          <div className="card-body pb-3">
            <form onSubmit={handleSubmit}>
              <div className="input-group input-group-outline mb-3">
                <label className="form-label">First Name</label>
                <input type="text" className="form-control" id="first_name" name="first_name" value={formData.first_name} onChange={handleInputChange}/> 
              </div>
              <div className="input-group input-group-outline mb-3">
                <label className="form-label">Last Name</label>
                <input type="text" className="form-control" id="last_name" name="last_name" value={formData.last_name} onChange={handleInputChange}/> 
              </div>
              <div className="input-group input-group-outline mb-3">
                <label className="form-label">Email</label>
                <input type="email" className="form-control" id="email" name="email" value={formData.email} onChange={handleInputChange}/> 
              </div>
              <div className="input-group input-group-outline mb-3">
                <label className="form-label">Password</label>
                <input type="password" className="form-control" id="password" name="password" value={formData.password} onChange={handleInputChange} /> 
              </div>
              <div className="input-group input-group-outline mb-3">
                <label className="form-label">City</label>
                <input type="address" className="form-control" id="city" name="city" value={formData.city} onChange={handleInputChange}/> 
              </div>
              <div className="input-group input-group-outline mb-3">
                <label htmlFor="state-select" className="form-label">State</label>
                <div className="form-control" >
                <select id="state-select" name="state" className="form-control" value={formData.state} onChange={handleInputChange}>
                  <option value="AL">Alabama</option>
                  <option value="AK">Alaska</option>
                  <option value="AZ">Arizona</option>
                  <option value="AR">Arkansas</option>
                  <option value="CA">California</option>
                  <option value="CO">Colorado</option>
                  <option value="CT">Connecticut</option>
                  <option value="DE">Delaware</option>
                  <option value="DC">District Of Columbia</option>
                  <option value="FL">Florida</option>
                  <option value="GA">Georgia</option>
                  <option value="HI">Hawaii</option>
                  <option value="ID">Idaho</option>
                  <option value="IL">Illinois</option>
                  <option value="IN">Indiana</option>
                  <option value="IA">Iowa</option>
                  <option value="KS">Kansas</option>
                  <option value="KY">Kentucky</option>
                  <option value="LA">Louisiana</option>
                  <option value="ME">Maine</option>
                  <option value="MD">Maryland</option>
                  <option value="MA">Massachusetts</option>
                  <option value="MI">Michigan</option>
                  <option value="MN">Minnesota</option>
                  <option value="MS">Mississippi</option>
                  <option value="MO">Missouri</option>
                  <option value="MT">Montana</option>
                  <option value="NE">Nebraska</option>
                  <option value="NV">Nevada</option>
                  <option value="NH">New Hampshire</option>
                  <option value="NJ">New Jersey</option>
                  <option value="NM">New Mexico</option>
                  <option value="NY">New York</option>
                  <option value="NC">North Carolina</option>
                  <option value="ND">North Dakota</option>
                  <option value="OH">Ohio</option>
                  <option value="OK">Oklahoma</option>
                  <option value="OR">Oregon</option>
                  <option value="PA">Pennsylvania</option>
                  <option value="RI">Rhode Island</option>
                  <option value="SC">South Carolina</option>
                  <option value="SD">South Dakota</option>
                  <option value="TN">Tennessee</option>
                  <option value="TX">Texas</option>
                  <option value="UT">Utah</option>
                  <option value="VT">Vermont</option>
                  <option value="VA">Virginia</option>
                  <option value="WA">Washington</option>
                  <option value="WV">West Virginia</option>
                  <option value="WI">Wisconsin</option>
                  <option value="WY">Wyoming</option>
                </select>
                </div>
              </div>
              <div className="input-group input-group-outline mb-3">
                <label className="form-label">Zip Code</label>
                <input type="text" pattern="\d{5,5}(-\d{4,4})?" maxLength="10" className="form-control" id="zip_code" name="zip_code" value={formData.zip_code} onChange={handleInputChange}/> 
              </div>
              <div className="input-group input-group-outline mb-3">
                <label className="form-label">Street Address</label>
                <input type="text" className="form-control" id="street_address" name="street_address" value={formData.street_address} onChange={handleInputChange}/> 
              </div>
              <div className="form-check text-left">
                <input className="form-check-input bg-dark border-dark" type="checkbox" value="" id="flexCheckDefault" checked/> 
                <label className="form-check-label" htmlFor="flexCheckDefault">I agree the <a href="../../pages/privacy.html" className="text-dark font-weight-bolder">Terms and Conditions</a></label><label className="form-check-label" htmlFor="flexCheckDefault">
                  I agree the <a href="../../pages/privacy.html" className="text-dark font-weight-bolder">Terms and Conditions</a>
                </label>
              </div>
              <div className="text-center">
                <button type="submit" className="btn bg-gradient-dark w-100 mt-4 mb-0">Sign up</button>
              </div>
            </form>
          </div>
          <div className="card-footer text-center pt-0 px-sm-4 px-1">
            <p className="mb-4 mx-auto">
              Already have an account?
              <a href="../../pages/sign-in/sign-in-cover.html" className="text-primary text-gradient font-weight-bold">Sign in</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

        </div>
      );
    }
    
    export default SignUp;